import {
  getCurrencySelect,
  getCurrencySelectArea,
  getCurrencySelectText,
} from '../selectors';

const isSelectRendered = () => {
  const currencySelectText = getCurrencySelectText();
  if (!currencySelectText) {
    return false;
  }

  const select = getCurrencySelect();
  const nonEmptySelect = select.innerHTML !== '';
  return nonEmptySelect;
};

const renderSelect = (targetCurrency, currencies, onChangeHandler) => {
  const currencySelectText = getCurrencySelectText();
  if (!currencySelectText) {
    return;
  }
  currencySelectText.textContent = targetCurrency;

  const select = getCurrencySelect();
  const options = currencies
    .map((currency) => `<option value=${currency}>${currency}</option>`)
    .join('');
  select.innerHTML = options;
  select.value = targetCurrency;

  select.addEventListener('change', (event) => {
    const newTargetCurrency = event.target.value;
    currencySelectText.textContent = newTargetCurrency;
    onChangeHandler(newTargetCurrency);
  });
};

const hideSelect = () => {
  const selectArea = getCurrencySelectArea();
  selectArea.style.display = 'none';
};

export { renderSelect, hideSelect, isSelectRendered };
